import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button, { defaultClassNames } from './Button';

SolidButton.propTypes = {
  icon: PropTypes.object,
  label: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default function SolidButton(props) {
  const {
    children,
    label,
    onClick,
    disabled,
    icon
  } = props;

  return (
    <Button
      icon={icon && (
        <props.icon className={classNames(
          'h-5 w-5',
          'text-white'
        )} />
      )}
      label={label || children}
      onClick={onClick}
      disabled={disabled}
      overrideClassNames={{
        ...defaultClassNames,
        background:  'bg-cs-orange-500',
        textColor:  'text-white',
        hover:  !disabled && 'cursor-pointer hover:bg-cs-orange-400',
      }}
    />
  );
};
